import { ArticlePage2 } from './ArticlePage2.js';

export class ArticlePageAPL7 extends ArticlePage2 {
    constructor(containerId) {
        super(containerId, {
            headline: "High-scoring action",
            author: "footballgirl",
               date: "Fevrier, 2026",
            image: "images/apl/7a.jpg",
            content: `<p>Recent high-scoring action in Arkema Première Ligue Matchday 16
Matchday 16 featured a total of 21 goals across fixtures, highlighted by OL Lyonnes' dominant performance in Marseille (a masterclass win).
 Other results included PSG Féminines beating RC Lens, Paris FC comfortably defeating Le Havre, and strong showings from other teams. This reflects the league's attacking flair and ongoing matches in the 2025/2026 season.</p>`,
             tags: ["france", "England", "U23", "Arkema Première Ligue"],
            readingTime: "6 min read",  
            navIndices: { prev: 'apl-6', next: 'apl-8' }
        });
    }

    init() {
        console.log('ArticlePageAPL7 initialized');
        super.init();
    }

    render() {
        super.render();
        
        const backBtn = this.element.querySelector('#articleBackBtn');
        if (backBtn) {
            backBtn.innerHTML = `
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width: 16px; height: 16px; margin-right: 6px;">
                    <line x1="19" y1="12" x2="5" y2="12"></line>
                    <polyline points="12 19 5 12 12 5"></polyline>
                </svg>
                Back to APL
            
<div style="margin:24px auto;max-width:720px;text-align:center;"><script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-7705230222200385" crossorigin="anonymous"></script><ins class="adsbygoogle" style="display:block;text-align:center;" data-ad-layout="in-article" data-ad-format="fluid" data-ad-client="ca-pub-7705230222200385" data-ad-slot="1708603458"></ins><script>(adsbygoogle = window.adsbygoogle || []).push({});</script></div>
`;
            
            const newBackBtn = backBtn.cloneNode(true);
            backBtn.parentNode.replaceChild(newBackBtn, backBtn);
            
            newBackBtn.addEventListener('click', (e) => {
                e.preventDefault();
                const event = new CustomEvent('navigateHome', { bubbles: true, detail: { anchor: 'apl' } });
                this.element.dispatchEvent(event);
            });
        }

        const leagueLogo = this.element.querySelector('.hero-util-btn img');
        if (leagueLogo) {
            leagueLogo.src = '/images/league_apl.png';
            leagueLogo.alt = 'APL';
        }
    }
}